import { AsyncPipe, NgClass, TitleCasePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ReferralStatus } from '@fitness-force/enum';
import { TagModule } from 'primeng/tag';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'app-referral-status',
  templateUrl: './referral-status.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TagModule, AsyncPipe, NgClass, TitleCasePipe],
})
export class ReferralStatusComponent {
  columnData: Observable<any> = new BehaviorSubject(null);
  additionData: Observable<any> = new BehaviorSubject(null);

  /**
   * Resolves a status value (string key like "Booked" or numeric value like 1 or "1")
   * to the ReferralStatus numeric enum value for consistent switching.
   */
  private resolveStatusValue(status: any): ReferralStatus | null {
    if (status === null || status === undefined || status === '') return null;

    // Already a number
    if (typeof status === 'number') return status as ReferralStatus;

    // Numeric string like "0", "1", "2"
    const asNumber = Number(status);
    if (
      !isNaN(asNumber)
      && ReferralStatus[asNumber as ReferralStatus] !== undefined
    ) {
      return asNumber as ReferralStatus;
    }

    // String key like "Booked" or "NoShow"
    const enumValue = ReferralStatus[status as keyof typeof ReferralStatus];
    return enumValue !== undefined ? enumValue : null;
  }

  setReferralStatus(status: any): string {
    const resolved = this.resolveStatusValue(status);
    if (resolved === null) return status ?? '';

    // Return the enum key name (e.g. "NoShow" → "No Show" is handled in template via titlecase)
    return ReferralStatus[resolved] ?? status;
  }

  getStatusColor(status: any): string {
    const resolved = this.resolveStatusValue(status);

    switch (resolved) {
      case ReferralStatus.Expired:
        return 'bg-red-400';
      case ReferralStatus.Active:
        return 'bg-green-400';
      case ReferralStatus.Successful:
        return 'bg-blue-400';
      default:
        return 'bg-gray-400';
    }
  }
}
